import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Stats = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-dark border-y border-border-dark/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {t.stats.map((stat) => (
            <div key={stat.label} className="rounded-2xl bg-card-dark border border-border-dark p-6 text-center">
              <p className="text-3xl sm:text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-primary-light to-accent font-heading">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-slate-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
